import { configuration } from '../App';

export function formatUrl({ id, type }) {
  return `https://firebasestorage.googleapis.com/v0/b/${configuration.projectId}.appspot.com/o/images%2F${id}%2F${type}?alt=media`;
}

export function getUrlImage({ id, type, image }) {
  return image && image.read && image.read[type] ? formatUrl({ id, type }) : formatUrl({ id, type: 'original' });
}
